import * as React from 'react'

const SvgBasicIcon = (props) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="2" y="2" width="32" height="32" rx="16" fill="#FFF4ED" />
    <path
      d="M23.3327 22.6667V20.6667H14.666C13.5614 20.6667 12.666 21.5621 12.666 22.6667M15.866 24.6667H21.1993C21.9461 24.6667 22.3195 24.6667 22.6047 24.5214C22.8556 24.3936 23.0595 24.1896 23.1874 23.9387C23.3327 23.6535 23.3327 23.2801 23.3327 22.5334V13.4667C23.3327 12.72 23.3327 12.3466 23.1874 12.0614C23.0595 11.8105 22.8556 11.6065 22.6047 11.4787C22.3195 11.3334 21.9461 11.3334 21.1993 11.3334H15.866C14.7459 11.3334 14.1859 11.3334 13.758 11.5514C13.3817 11.7431 13.0757 12.0491 12.884 12.4254C12.666 12.8532 12.666 13.4133 12.666 14.5334V21.4667C12.666 22.5868 12.666 23.1469 12.884 23.5747C13.0757 23.951 13.3817 24.257 13.758 24.4487C14.1859 24.6667 14.7459 24.6667 15.866 24.6667Z"
      stroke="#FF692E"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="2"
      y="2"
      width="32"
      height="32"
      rx="16"
      stroke="#FFE6D5"
      strokeWidth="4"
    />
  </svg>
)

export default SvgBasicIcon
